<template>
  <b-modal
    id="modal-1"
    class="testconfigmodal"
    centered
    hide-footer
    hide-header
    size="xl"
    no-close-on-backdrop
    @shown="populateConfig"
    @hidden="$bvModal.hide('modal-1')"
    ><div class="d-flex tc-modal-body">
      <div class="cs-left-modal-back"></div>
      <div class="body-div-right-tc">
        <div class="p-3 mt-2 conf-form-head">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex px-2">
              <div class="mr-3" @click="$bvModal.hide('modal-1')">
                <img src="../../../assets/customfield/blueBackArrow.svg" />
              </div>
              <div class="modal-heading-form">View Configuration</div>
            </div>
            <div
              @click="$bvModal.hide('modal-1')"
              class="xmark-modal-pos-tc rotate-on-hover pointer"
            >
              <img src="../../../assets/panelist/blue_cross.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="mt-3 pan-log-tabs-tc">
          <b-tabs v-model="tabIndex" content-class="mt-3">
            <b-tab active>
              <template #title>
                Opening Screen Display
                <div v-if="tabIndex == 0" class="tc-tab-sel"></div>
              </template>
              <div class="pr-2 configcontent-tabs-content px-5">
                <b-row class="pb-1">
                  <b-col>
                    <div class="tc-form-fields mt-3 position-relative">
                      <label class="tc-form-labels"
                        >Configuration Name<span class="asterik">*</span></label
                      >
                      <b-form-input
                        class="mt-1"
                        type="text"
                        placeholder="Enter Here"
                        disabled
                        v-model.trim="context.configName"
                      ></b-form-input>
                    </div>
                  </b-col>
                  <b-col>
                    <div class="tc-form-fields mt-3 relativeclass">
                      <label class="tc-form-labels"
                        >Test Organiser<span class="asterik">*</span></label
                      >
                      <b-form-input
                        class="mt-1"
                        id="input-1"
                        type="text"
                        placeholder="Enter Here"
                        disabled
                        v-model.trim="context.testConfigData.config.testOrg"
                      ></b-form-input>
                    </div>
                  </b-col>
                  <b-col>
                    <div class="mt-3 tc-form-fields">
                      <label class="tc-form-labels"
                        >Test<span class="asterik">*</span></label
                      >
                      <div class="mt-1">
                        <SelectDropdown
                          :type="'filter'"
                          :dropdownOptions="testoptions"
                          :disableDropdown="true"
                          :value="context.testConfigData.config.test"
                          :placeholder="'Select'"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="topDiv mt-4 relativeclass">
                      <label class="tc-form-labels"
                        >Test Description<span class="asterik">*</span></label
                      >
                      <div>
                        <QuillEditor
                          :value="context.testConfigData.config.testDesc"
                          :disableQuill="true"
                        >
                        </QuillEditor>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="d-flex tc-btnsDiv justify-content-end p-3">
                <div class="add-btn-tc">
                  <b-button @click="tabIndex++" class="h-32 w-87 ml-4"
                    ><span class="add-btn-tc-txt">Next</span></b-button
                  >
                </div>
              </div>
            </b-tab>

            <b-tab>
              <template #title>
                Question Behaviour

                <div v-if="tabIndex == 1" class="tc-tab-sel"></div>
              </template>
              <div class="pr-2 configcontent-tabs-content px-5">
                <b-row>
                  <b-col>
                    <div class="tc-form-fields topDiv mt-3 relativeclass">
                      <label class="tc-form-labels"
                        >Start Test Date & Time
                        <span class="asterik">*</span></label
                      >
                      <datetime
                        placeholder="Select Start Date & Time"
                        ref="startDate"
                        id="input-1"
                        class="startdateconfig-tc global-disabledField mt-1"
                        type="datetime"
                        disabled
                        use12-hour
                        v-model="context.testConfigData.config.openTestdt"
                      ></datetime>
                      <img
                        class="calender-image-tc"
                        src="../../../assets/img/config-modules/calendar-week.svg"
                        alt=""
                      />
                    </div>
                  </b-col>
                  <b-col>
                    <div class="tc-form-fields topDiv mt-3 relativeclass">
                      <label class="tc-form-labels"
                        >End Test Date & Time<span class="asterik">*</span>
                      </label>

                      <datetime
                        ref="endDate"
                        placeholder="Select End Date & Time"
                        class="startdateconfig-tc mt-1"
                        type="datetime"
                        id="input-1"
                        disabled
                        use12-hour
                        v-model="context.testConfigData.config.closeTestdt"
                      ></datetime>
                      <img
                        class="calender-image-tc"
                        src="../../../assets/img/config-modules/calendar-week.svg"
                        alt=""
                      />
                    </div>
                  </b-col>
                  <b-col>
                    <div class="tc-form-fields mt-3 relativeclass">
                      <label class="tc-form-labels"
                        >Test Duration(Minutes)<span class="asterik"
                          >*</span
                        ></label
                      >
                      <b-form-input
                        id="input-1"
                        class="mt-1"
                        placeholder="Enter Duration in Minutes"
                        type="text"
                        disabled
                        v-model="context.testConfigData.config.testDuration"
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <div class="tc-form-fields mt-3 relativeclass">
                      <label class="tc-form-labels"
                        >Passing Percentage<span class="asterik">*</span></label
                      >
                      <b-form-input
                        id="input-1"
                        type="text"
                        class="mt-1"
                        placeholder="Enter Here"
                        v-model.trim="
                          context.testConfigData.config.passingPercentage
                        "
                        disabled
                      ></b-form-input>
                    </div>
                  </b-col>
                  <b-col>
                    <div class="tc-form-fields mt-3 position-relative">
                      <label class="tc-form-labels"
                        >Number of Questions Per Screen
                        <span class="asterik">*</span></label
                      >
                      <b-form-input
                        type="text"
                        placeholder="Enter Here"
                        class="mt-1"
                        v-model.trim="
                          context.testConfigData.config.quesPerScreen
                        "
                        disabled
                      ></b-form-input>
                    </div>
                  </b-col>
                  <b-col>
                    <div class="tc-form-fields mt-3 relativeclass">
                      <label class="tc-form-labels"
                        >Specify Negative Marks
                        <span class="asterik">*</span></label
                      >
                      <b-form-input
                        id="input-1"
                        type="text"
                        class="mt-1"
                        placeholder="Enter Here"
                        v-model.trim="
                          context.testConfigData.config.negativeMarkValue
                        "
                        disabled
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="mt-2">
                  <b-col cols="4">
                    <div class="tc-form-fields mt-3 position-relative">
                      <label class="tc-form-labels"
                        >Maximum Number of Attempts
                        <span class="asterik">*</span></label
                      >
                      <b-form-input
                        type="text"
                        placeholder="Enter Here"
                        v-model.trim="
                          context.testConfigData.config.maxnoattempts
                        "
                        disabled
                      ></b-form-input>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="tc-form-fields mt-3 relativeclass">
                      <label class="tc-form-labels"
                        >Buffer Time (minutes)
                        <span class="asterik">*</span></label
                      >
                      <b-form-input
                        id="input-1"
                        type="text"
                        placeholder="Enter Here"
                        v-model.trim="context.testConfigData.config.buffertime"
                        disabled
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col cols="8">
                    <label class="tc-form-labels mt-3" style="left: 0">
                      Time Between Attempts
                      <span class="asterik">*</span></label
                    >
                  </b-col>
                  <b-col cols="4">
                    <label
                      v-if="context.testConfigData.config.maxnoattempts > 1"
                      class="tc-form-labels mt-3"
                      style="left: 0"
                    >
                      Priority Attempt <span class="asterik">*</span></label
                    >
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <div class="position-relative mt-2">
                      <div
                        class="
                          time-div-tc
                          d-flex
                          justify-content-between
                          global-disabledField
                        "
                      >
                        <span>{{
                          context.testConfigData.config.timebnsel == "hrs"
                            ? "Hours"
                            : context.testConfigData.config.timebnsel == "mins"
                            ? "Minutes"
                            : context.testConfigData.config.timebnsel == "days"
                            ? "Days"
                            : "Select"
                        }}</span>

                        <div></div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="tc-form-fields mt-2 relativeclass pb-2">
                      <b-form-input
                        id="input-1"
                        type="text"
                        :placeholder="`${
                          context.testConfigData.config.timebnsel == 'hrs'
                            ? 'Enter in Hours'
                            : context.testConfigData.config.timebnsel == 'mins'
                            ? 'Enter in Minutes'
                            : context.testConfigData.config.timebnsel == 'days'
                            ? 'Enter in Days'
                            : 'Enter Time'
                        }`"
                        v-model="context.testConfigData.config.timebnvalue"
                        disabled
                      ></b-form-input>
                    </div>
                  </b-col>
                  <b-col
                    class="mt-2"
                    v-if="context.testConfigData.config.maxnoattempts > 1"
                  >
                    <div
                      class="fdf-add-container d-flex align-items-center mt-2"
                    >
                      <b-form-radio-group
                        class="priority-labels"
                        :options="priorityoptions"
                        v-model="context.testConfigData.config.priority"
                        disabled
                        value-field="item"
                        text-field="name"
                        size="sm"
                      ></b-form-radio-group>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col cols="4">
                    <div class="checkbox-list configpage-checkbox">
                      <b-form-checkbox
                        size="md"
                        class="mt-3"
                        name="checkbox-1"
                        v-model="context.testConfigData.config.displayReqFirst"
                        disabled
                      >
                        Display Mandatory Questions First
                      </b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="checkbox-list configpage-checkbox">
                      <b-form-checkbox
                        size="md"
                        class="mt-3"
                        name="checkbox-1"
                        v-model="context.testConfigData.config.dispMarks"
                        disabled
                      >
                        Display Marks for every Questions
                      </b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="checkbox-list configpage-checkbox">
                      <b-form-checkbox
                        size="md"
                        class="mt-3"
                        name="checkbox-1"
                        v-model="context.testConfigData.config.shuffle"
                        disabled
                      >
                        Randomly Shuffle Questions
                      </b-form-checkbox>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="mt-3">
                  <b-col cols="4">
                    <div class="checkbox-list configpage-checkbox">
                      <b-form-checkbox
                        size="md"
                        class="mt-3 checkbox-list"
                        name="checkbox-1"
                        v-model="context.testConfigData.config.dispReqStatus"
                        disabled
                      >
                        Display Mandatory Questions Icon
                      </b-form-checkbox>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="d-flex tc-btnsDiv justify-content-end p-3">
                <div class="cancelpan-btn">
                  <b-button
                    @click="$bvModal.hide('modal-1')"
                    class="h-32 w-87 ml-2"
                    >Cancel</b-button
                  >
                </div>
                <div class="add-btn-tc">
                  <b-button @click="tabIndex++" class="h-32 w-87 ml-4"
                    ><span class="add-btn-tc-txt">Next</span></b-button
                  >
                </div>
              </div>
            </b-tab>

            <b-tab>
              <template #title>
                System Setup

                <div v-if="tabIndex == 2" class="tc-tab-sel"></div>
              </template>
              <div class="pr-2 configcontent-tabs-content px-5">
                <b-row>
                  <b-col>
                    <div>
                      <b-row>
                        <b-col cols="4">
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              disabled
                              v-model="
                                context.testConfigData.config.communicationTest
                              "
                              name="checkbox-1"
                            >
                              Communication Test
                            </b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col cols="4">
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              v-model="
                                context.testConfigData.config.enableProctoring
                              "
                              name="checkbox-1"
                              disabled
                            >
                              Enable Proctoring
                            </b-form-checkbox>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="4">
                          <div class="tc-form-fields mt-3 relativeclass">
                            <label class="tc-form-labels"
                              >Communication Test Attempts<span class="asterik"
                                >*</span
                              ></label
                            >
                            <b-form-input
                              class=""
                              id="input-1"
                              placeholder="Enter Here"
                              type="text"
                              v-model.trim="
                                context.testConfigData.config
                                  .communicationTestAttempts
                              "
                              disabled
                            ></b-form-input>
                          </div>
                        </b-col>
                        <b-col cols="4">
                          <div class="tc-form-fields mt-3 relativeclass">
                            <label class="w-303 tc-form-labels"
                              >Set Image Capture Timing-Slot (Seconds)
                              <span class="asterik">*</span></label
                            >
                            <b-form-input
                              class=""
                              id="input-1"
                              disabled
                              placeholder="Enter Here"
                              type="text"
                              v-model.trim="
                                context.testConfigData.config.screenCapture
                              "
                            ></b-form-input>
                          </div>
                        </b-col>
                        <b-col class="mt-3">
                          <div class="checkbox-list mt-3 relativeclass d-flex">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              name="checkbox-1"
                              disabled
                              v-model="
                                context.testConfigData.config.enableCamera
                              "
                            >
                              Enable Video
                            </b-form-checkbox>
                            <img
                              v-if="context.testConfigData.config.enableCamera"
                              src="../../../assets/img/config-modules/popup-icon-blue.svg"
                              alt=""
                              class="mt-3 ml-1"
                              v-b-popover.hover.top="{
                                content:
                                  'Enabled video since proctoring is enabled',
                              }"
                            />
                          </div>
                        </b-col>
                      </b-row>

                      <hr class="mt-4 mb-2" />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div>
                      <b-row>
                        <b-col>
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              v-model="
                                context.testConfigData.config
                                  .allowImageAndIdCapture
                              "
                              disabled
                              name="checkbox-1"
                            >
                              Allow Image And ID Capture
                            </b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              name="checkbox-1"
                              disabled
                              v-model="context.testConfigData.config.typingTest"
                            >
                              Typing Test
                            </b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              name="checkbox-1"
                              disabled
                              v-model="
                                context.testConfigData.config.instantemail
                              "
                              >Instant Test Result
                            </b-form-checkbox>
                          </div>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col>
                          <div class="checkbox-list Div mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              v-model="context.testConfigData.config.allowAgent"
                              name="checkbox-1"
                              disabled
                              >Allow Agent
                            </b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              name="checkbox-1"
                              disabled
                              v-model="
                                context.testConfigData.config
                                  .allowCandidateRemarks
                              "
                            >
                              Allow Candidate Feedback
                            </b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              v-model="
                                context.testConfigData.config.enableScreenShare
                              "
                              size=" md"
                              name="checkbox-1"
                              disabled
                            >
                              Enable Screen Share
                            </b-form-checkbox>
                          </div>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col>
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              disabled
                              v-model="
                                context.testConfigData.config
                                  .includeTimeNotifics
                              "
                              name="checkbox-1"
                            >
                              Include Time Sensitivity Notifications
                            </b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              v-model="
                                context.testConfigData.config.allowExtension
                              "
                              size=" md"
                              disabled
                              name="checkbox-1"
                            >
                              Allow Extension
                            </b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="checkbox-list mt-3 relativeclass">
                            <b-form-checkbox
                              class="mt-3"
                              size=" md"
                              name="checkbox-1"
                              v-model="
                                context.testConfigData.config.internetCheck
                              "
                              disabled
                            >
                              <div class="">Enable Internet Check</div>
                            </b-form-checkbox>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="d-flex tc-btnsDiv justify-content-end p-3">
                <div class="cancelpan-btn">
                  <b-button
                    @click="$bvModal.hide('modal-1')"
                    class="h-32 w-87 ml-2"
                    >Cancel</b-button
                  >
                </div>
                <div class="add-btn-tc">
                  <b-button @click="tabIndex++" class="h-32 w-87 ml-4"
                    ><span class="add-btn-tc-txt">Next</span></b-button
                  >
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template #title>
                Do’s and Dont’s

                <div v-if="tabIndex == 3" class="tc-tab-sel"></div>
              </template>
              <div class="pr-2 configcontent-tabs-content px-5">
                <div class="dos-donts-head-tc">Do's & Dont’s</div>
                <div class="dos-donts-head-tc">
                  (Min 1 required)<span class="asterik">*</span>
                </div>

                <div
                  v-for="(i, index) in context.testConfigData.config
                    .dosAndDonts"
                  :key="index"
                  class="mt-3"
                >
                  <div class="d-flex">
                    <div class="d-flex dos-donts-fields w-96 position-relative">
                      <div class="mr-2 mt-2">
                        <span class="dos-donts-num">{{ index + 1 }}. </span>
                      </div>
                      <b-form-input
                        autofocus
                        class="pointer"
                        placeholder="Enter"
                        v-model.trim="
                          context.testConfigData.config.dosAndDonts[index].value
                        "
                        type="text"
                        disabled
                      ></b-form-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex tc-btnsDiv justify-content-end p-3">
                <div class="add-btn-tc">
                  <b-button
                    class="h-32 w-87 ml-2"
                    @click="$bvModal.hide('modal-1')"
                    ><span class="add-btn-tc-txt"> Close</span>
                  </b-button>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import QuillEditor from "../../../components/fixedcomponents/quillEditor.vue";
import { selectDosAndDonts, closeConfigView } from "../helpers";
import SelectDropdown from "../../../components/fixedcomponents/Select.vue";
export default {
  name: "ConfigureTestModal",
  components: {
    QuillEditor,
    SelectDropdown,
  },
  props: {
    context: Object,
  },

  data() {
    return {
      selectOptions: {
        text: "",
        value: "",
      },
      globalWorks: false,
      tabIndex: 0,
      testoptions: [
        {
          text: "Public",
          value: "public",
        },
        {
          text: "Private",
          value: "private",
        },
      ],
      editorConfig: {
        toolbar: [["Bold", "Italic", "-", "NumberedList", "BulletedList", "-"]],
      },
      testinstruction: "not_accepted",
      priorityoptions: [
        {
          item: "first",
          name: "First",
        },
        {
          item: "last",
          name: "Last",
        },
        {
          item: "highestScored",
          name: "Highest Scored",
        },
      ],
    };
  },
  methods: {
    populateConfig() {
      let obj = this.testoptions.find(
        (item) => item.value === this.context.testConfigData.config.test
      );
      this.selectOptions.value = obj.value;
      this.selectOptions.text = obj.text;
    },
    selectDosAndDonts(value, id) {
      selectDosAndDonts(this.context, value, id);
    },
    closeConfigView() {
      closeConfigView(this.context);
    },
  },
};
</script>

<style scoped>
.configuration-topDiv > .inputField {
  font-family: "Poppins", sans-serif;
  border: 1px solid #bbbbbb;
  border-radius: 3px !important;
  font-size: var(--size-12);
  color: #6d6d6d;
  box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
  box-sizing: border-box;
}
</style>
<style>
.cj-test-section-tabs .tab-pane {
  height: calc(100vh - 200px);
  overflow-x: hidden;
  overflow-y: auto;
}

.cj-test-section-tabs .nav-tabs {
  background: #faf9f9;
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  width: 100%;
}

.cj-test-section-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: white;
  background: #72738e;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  padding: 7px 79px;
  position: relative;
}

.cj-test-section-tabs .nav-tabs .nav-link {
  font-weight: var(--weight-LM);
  font-size: var(--size-14);
  padding: 7px 73px;
  position: relative;
  min-width: 150px;

  color: var(--btn-border);
  margin-bottom: none;
  border: none;
  border-top-left-radius: none;
  border-top-right-radius: none;
  text-align: center;
}
.prev-btn {
  position: absolute;
  bottom: 10px;
  left: 9px;
}
.testconfig-topDiv-name > .inputField {
  border: 0.7px solid var(--input-border);
  border-radius: 3px !important;
  font-size: 14px;
  background: var(--bg-inputfield);
  color: #6d6d6d;
  box-sizing: border-box;
  padding: 0.5rem 0.75rem;
  padding-right: 2rem;
  height: calc(1.5em + 0.75rem + 2px);
}
.add-btn-tc .btn-secondary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 10px 5px 10px;
  gap: 10px;
  background: #20639b;
  border-radius: 40px;
}
.add-btn-tc .btn-secondary:hover {
  color: var(--bg-white);
  background-color: #20639b;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.add-btn-tc .btn-secondary:not(:disabled):not(.disabled):active,
.add-btn-tc .btn-secondary:not(:disabled):not(.disabled).active,
.add-btn-tc .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #20639b;
  border-color: #20639b;
}
.add-btn-tc-txt {
  font-family: "Montserrat", sans-serif, sans-serif;
  font-weight: 600;
  font-size: 13px;
  /* identical to box height */
  display: flex;
  align-items: center;

  color: #ffffff;
}

.startdateconfig-tc > input {
  border: 1px solid #d0d5dd;
  padding: 10px 14px 10px 14px;
  width: 300px;
  height: 37px;
  border-radius: 8px;
  width: 300px;
}
</style>
